module.exports = __webpack_public_path__ + "img/ic_welfare.9d169be9.png";